module.exports = __webpack_public_path__ + "static/media/tech.1a0db62b.jpg";